import React, { useState } from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import { Avatar } from "antd";
import { useLocation } from "react-router-dom";

import BottomNavigationBar from './BottomNavigation';
import { makePostRequest } from "../API";

const PassportDetails = () => {
  const [selectedImages, setSelectedImages] = useState({});
  const location = useLocation();
  const Dashboard = location && location.state?.responseData;
  console.log(Dashboard, "Dashboard");
  const handleImageSelect = (event) => {
    const file = event.target.files[0];
    const inputId = event.target.id;

    setSelectedImages((prevState) => ({
      ...prevState,
      [inputId]: file,
    }));
  };

  const handleImageRemove = (inputId) => {
    const { [inputId]: removedImage, ...updatedImages } = selectedImages;
    setSelectedImages(updatedImages);
  };

  const handleFormSubmit = async () => {
    const formData = new FormData();
    formData.append("pilgrim_id", Dashboard.id);

    for (const key in selectedImages) {
      formData.append("passport[]", selectedImages[key]);
    }

    try {
      const response = await makePostRequest(
        "api/umrah/passport/store",
        formData
      );
      console.log(response);
      alert("Submitted!!");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="page-font"
      style={{
        width: "100%"
      }}
    >
      <div className="background-image-upload-passport">
        {/* <MDBContainer breakpoint=" p-4"> */}
          <div className="main-wrapper">
            <div style={{ paddingbottom: "50px" }}>
              <div
                className="navebar"
                style={{ background: "", width: "100%", marginBottom: "10px" }}
              >
                <img className="logo" src={window.logo}  alt="logo" />
                <Avatar
                  className="profile"
                  alt="Remy Sharp"
                  src={window.profile}
                />
              </div>

              <div className="p-4 background-img">
                <div className="hotel-cards-wrapper">
                  <h1>Passport Details</h1>
                </div>
                <div className="info-card">
                  <div className="passport-details">
                    {
                    Dashboard.passport_no &&
                      <p>
                      <b>Passport Number:</b> {Dashboard.passport_no}
                    </p>
                    }
                    {
                    Dashboard.first_name &&
                    <p>
                      <b>First Name:</b> {Dashboard.first_name}
                    </p>
                    }
                    {
                    Dashboard.last_name &&
                      <p>
                      <b>Last Name:</b> {Dashboard.last_name}
                    </p>
                    }
                    {
                    Dashboard.date_of_birth &&
                      <p>
                      <b>Date Of Birth:</b> {Dashboard.date_of_birth}
                    </p>
                    }
                    {
                      Dashboard.nationality &&
                      <p>
                      <b>Nationality:</b> {Dashboard.nationality}
                    </p>
                    }
                    {
                      Dashboard.id && 
                      <p>
                      <b>Id Number:</b> {Dashboard.id}
                    </p>
                    }
                    {
                      Dashboard.expiry_date &&
                      <p>
                      <b>Expiry Date:</b> {Dashboard.expiry_date}
                    </p>
                    }
                    {
                      Dashboard.country &&
                      <p>
                      <b>Country Name:</b> {Dashboard.country}
                    </p>
                    }
                    {
                      Dashboard.citizen_number &&
                      <p>
                      <b>Citizen:</b> {Dashboard.citizen_number}
                    </p>
                    }
                  </div>
                  <hr />
                  <div>
                    {Dashboard &&
                      Dashboard.image.map((imageObj, index) => (
                        <div key={index}>
                          <div>
                            <p
                              style={{
                                fontWeight: "bold",
                              }}
                            >
                              {imageObj.name === "PassportFrontPic"
                                ? "Passport Front Page"
                                : imageObj.name === "PassportBackPic"
                                ? "Passport Back Page"
                                : "Booklet"}
                            </p>
                            <img
                              //set dynamic, relative image size
                              className="passport-image"
                              style={{ fontSize: "20px" }}
                              src={`data:image/png;base64,${imageObj.value}`}
                              alt={imageObj.name}
                            />
                          </div>
                          <div >
                            {imageObj.name === "PassportFrontPic" ? (
                              <div className="passport-selected-image">
                                <input
                                  type="file"
                                  id="frontImage"
                                  onChange={handleImageSelect}
                                  className="file-field"
                                />
                                {selectedImages.frontImage && (
                                  <div className="selected-image-container">
                                    <img
                                      className="selected-image"
                                      src={URL.createObjectURL(
                                        selectedImages.frontImage
                                      )}
                                      alt="Selected Front Image"
                                    />
                                    <button
                                      className="remove-image-button"
                                      onClick={() =>
                                        handleImageRemove("frontImage")
                                      }
                                    >
                                      Remove Front Image
                                    </button>
                                  </div>
                                )}
                              </div>
                            ) : imageObj.name === "PassportBackPic" ? (
                              <div className="passport-selected-image">
                                {/* <label htmlFor="backImage" style={{ fontSize: "20px" }}>
                              Upload Passport Back Page
                            </label> */}
                                <input
                                  type="file"
                                  id="backImage"
                                  onChange={handleImageSelect}
                                  className="file-field"
                                />
                                {selectedImages.backImage && (
                                  <div className="selected-image-container">
                                    <img
                                      className="selected-image"
                                      src={URL.createObjectURL(
                                        selectedImages.backImage
                                      )}
                                      alt="Selected Back Image"
                                    />
                                    <button
                                      className="remove-image-button"
                                      onClick={() =>
                                        handleImageRemove("backImage")
                                      }
                                    >
                                      Remove Back Image
                                    </button>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div className="passport-selected-image">
                                {/* <label htmlFor="bookLet" style={{ fontSize: "20px" }}>
                              Upload Booklet
                            </label> */}
                                <input
                                  type="file"
                                  id="bookLet"
                                  onChange={handleImageSelect}
                                  className="file-field"
                                />
                                {selectedImages.bookLet && (
                                  <div className="selected-image-container">
                                    <img
                                      className="selected-image"
                                      src={URL.createObjectURL(
                                        selectedImages.bookLet
                                      )}
                                      alt="Selected Booklet"
                                    />
                                    <button
                                      className="remove-image-button"
                                      onClick={() =>
                                        handleImageRemove("bookLet")
                                      }
                                    >
                                      Remove Booklet
                                    </button>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                  </div>
                  <div
                    className="passportdetailbutton mt-4"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <button onClick={handleFormSubmit}>Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        {/* </MDBContainer> */}
      </div>
      <div>
        <BottomNavigationBar />
      </div>
    </div>
  );
};

export default PassportDetails;
